module.exports = __webpack_public_path__ + "website/img/mobile1.0996b035.png";